/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardConfigViolationMonth {
    getFixupPrototypeFunction() { return SecurityDashboardConfigViolationMonth.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardConfigViolationMonth>): SecurityDashboardConfigViolationMonth {
        let obj = Object.assign(new SecurityDashboardConfigViolationMonth(), model);
        SecurityDashboardConfigViolationMonth.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardConfigViolationMonth>): SecurityDashboardConfigViolationMonth {
        if (!model) return null;
        return SecurityDashboardConfigViolationMonth.newInstance(<SecurityDashboardConfigViolationMonth> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardConfigViolationMonth) {
        if (!obj) return;

        models.SecurityDashboardConfigViolationMonth.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardConfigViolationMonth): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardConfigViolationMonth.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.month === "string") {
            this.month = new Date(<string><any>this.month);
        }
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Config Violation Month
     */
    month: Date;

    /**
     * Config Violations Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
